<div id="order-analysis" class="office-page">
    <!-- Main Content -->
    <div class="section-content">
        <div class="container office-block">
			<div class="calendar">
				<div class="calendar-header">
					<div class="nav-btn prev" id='minusbtn' (click)="handleOnClickCalendarButton('-');">
						<svg width="30" height="30" viewBox="0 0 30 30">
							<path d="M19.1008 24.3996L9.80078 14.9996L19.1008 5.59961L19.9008 6.39961L11.2008 14.9996L19.9008 23.5996L19.1008 24.3996Z" fill="#000" /></svg>
					</div>
					<div class="date h-xlarge">
						<span id="year">{{year}}</span>
					</div>
					<div class="nav-btn next" id='plusbtn' (click)="handleOnClickCalendarButton('+');">
						<svg width="30" height="30" viewBox="0 0 30 30">
							<path d="M10.5008 24.3996L19.9008 14.9996L10.5008 5.59961L9.80078 6.39961L18.4008 14.9996L9.80078 23.5996L10.5008 24.3996Z" fill="#000" /></svg>
					</div>
				</div>
			</div>
            <div class="results">
                <div class="row mgt50">
                    <div class="col-lg-4 col-md-12 age-chart">
                        <h2 class="h-small">계급</h2>
                        <div class="chart circle-chart">
                            <div id="chart-member-age" class="justify-content-center d-flex">
                                <google-chart #chart [type]="type" [data]="dataOrderChartRank" [options]="optionOrderChartRank" class="justify-content-center d-flex">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 age-chart">
                        <h2 class="h-small">나이</h2>
                        <div class="chart circle-chart">
                            <div id="chart-member-age" class="justify-content-center d-flex">
                                <google-chart #chart [type]="type" [data]="dataOrderChartAge" [options]="optionOrderChartAge" class="justify-content-center d-flex">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 age-chart">
                        <h2 class="h-small">범주</h2>
                        <div class="chart circle-chart">
                            <div id="chart-member-age" class="justify-content-center d-flex">
                                <google-chart #chart [type]="type" [data]="dataOrderChartCate" [options]="optionOrderChartCate" class="justify-content-center d-flex">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="position-chart mgt50">
                    <h2 class="h-small">월별 주문 분석</h2>
                    <div class="chart hr-chart mgt50" id="chart-member-rank">
                        <ul class="row value-row">
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon1 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon1)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon2 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon2)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon3 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon3)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon4 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon4)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon5 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon5)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon6 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon6)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon7 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon7)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon8 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon8)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon9 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon9)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon10 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon10)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon11 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon11)}"></span>
                            </li>
                            <li class="col">
                                <div class="value"><span>{{orderAnalysisMonth.mon12 | setComma}}</span></div>
                                <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElement(orderAnalysisMonth.mon12)}"></span>
                            </li>                            
                            <div class="hr-lines">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </ul>
                        <ul class="row label-row">
                            <li class="col">1월</li>
                            <li class="col">2월</li>
                            <li class="col">3월</li>
                            <li class="col">4월</li>
                            <li class="col">5월</li>
                            <li class="col">6월</li>
                            <li class="col">7월</li>
                            <li class="col">8월</li>
                            <li class="col">9월</li>
                            <li class="col">10월</li>
                            <li class="col">11월</li>
                            <li class="col">12월</li>
                        </ul>
                    </div>
                </div>
    
                <div class="position-chart mgt50">
                    <h2 class="h-small">상품별 수주 분석</h2>
                    <div class="chart hr-chart mgt50" id="chart-member-rank">
                        <ul class="row value-row">
                            <li class="col" *ngFor="let item of orderAnalysisProduct$ | async">
                                <ng-container *ngIf="getNumber(item.amt) > 0">
                                    <div class="value"><span>{{item.amt | setComma}}</span></div>
                                    <span class="bar" [ngStyle] = "{'height.px': getHeigthOfElementProduct(item.amt)}"></span>
                                </ng-container>                               
                            </li>
                            <div class="hr-lines">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </ul>
                        <ul class="row label-row">                            
                            <li class="col" *ngFor="let item of orderAnalysisProduct$ | async">
                                <ng-container *ngIf="getNumber(item.amt) > 0">
                                    {{item.pdtName}}
                                </ng-container>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        <!-- <div class="container default-container mobile-container">
            <div class="office-block result-block">
                <div class="calendar-header">
                  <div class="nav-btn prev" id='minusbtn' (click)="handleOnClickCalendarButton('-');">
                    <svg width="30" height="30" viewBox="0 0 30 30">
                      <path d="M19.1008 24.3996L9.80078 14.9996L19.1008 5.59961L19.9008 6.39961L11.2008 14.9996L19.9008 23.5996L19.1008 24.3996Z" fill="#000" /></svg>
                  </div>
                  <div class="date h-xlarge">
                    <span id="year">{{year}}</span>
                  </div>
                  <div class="nav-btn next" id='plusbtn' (click)="handleOnClickCalendarButton('+');">
                    <svg width="30" height="30" viewBox="0 0 30 30">
                      <path d="M10.5008 24.3996L19.9008 14.9996L10.5008 5.59961L9.80078 6.39961L18.4008 14.9996L9.80078 23.5996L10.5008 24.3996Z" fill="#000" /></svg>
                  </div>
                </div>
              </div> -->
            
        </div>
    </div>
</div>